import {
  GET_PRODUCT_TYPES,
  SET_ORDER_BY,
  SET_SORT_BY,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initialProductTypes = {
  productTypes: [],
  productTypeCount: 0,
  page: 1,
  search: "",
  orderby: "desc",
  sortby: "",
};

function productTypesReducer(state = initialProductTypes, action) {
  switch (action.type) {
    case GET_PRODUCT_TYPES:
      return {
        ...state,
        productTypes: action.payload.categories.map((type) => {
          return {
            ...type,

            updatedAtFormatted: moment(type.createdAt).format("ll"),
          };
        }),
        productTypeCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };

    default:
      return state;
  }
}

export default productTypesReducer;
